// extracted by css-extract-rspack-plugin
export default {"header":"Header_header__id5Uh","header__left":"Header_header__left__Cpd5U","header__right":"Header_header__right__wvbFl"};